import { render, staticRenderFns } from "./TranscribeBehaviorEditor.vue?vue&type=template&id=1cb27e9c&scoped=true&"
import script from "./TranscribeBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./TranscribeBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TranscribeBehaviorEditor.vue?vue&type=style&index=0&id=1cb27e9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb27e9c",
  null
  
)

export default component.exports